import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function TopMenuItemManage ( props ) {

    return <BasicCrudScreenType id="TopMenuItems" table="TopMenuItems" view="VwTopMenuItems" />;

}

export default TopMenuItemManage;
